import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * Helper method to securely mark if a user is inside the MyAccount portal.
   * Uses 'yes' or 'no' to prevent PII leakage.
   */
  setMyAccountAccessedState(hasAccessed: boolean): void {
    if (hasAccessed && !this.hasAccessedMyAccount()) {
      this.setDomainCookie('myAccountAccessed', 'yes', 365);
    }
  }

  /**
   * Checks if the MyAccount session is active based on the cookie.
   */
  hasAccessedMyAccount(): boolean {
    return this.getCookie('myAccountAccessed') === 'yes';
  }

  /**
   * Sets a domain-specific cookie
   */
  private setDomainCookie(name: string, value: string, expireDays: number = 7): void {
    const d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;

    // Target subdomains securely
    const domain = environment.env === 'local' ? `domain=${window.location.hostname}` : `domain=${this.getRootDomain()}`;
    const securityFlags = environment.env === 'local' ? 'path=/; SameSite=Lax' : 'path=/; Secure; SameSite=Lax';

    this.document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; ${domain}; ${securityFlags}`;
  }

  /**
   * Helper to derive the root domain (e.g. .cinchhs.com or .cinchhomeservices.com) from environment.domain
   */
  private getRootDomain(): string {
    const parts = environment.domain.split('.');
    if (parts.length >= 2) {
      return `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
    }
    return environment.domain;
  }

  /**
   * Retrieves a cookie by name
   */
  private getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const ca = this.document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }
}
